import React from "react";
import { useTranslation } from "react-i18next";
import imageSrc1 from "../../assets/images/icon-x.svg";
import imageSrc2 from "../../assets/images/icon-fb.svg";
import imageSrc3 from "../../assets/images/icon-in.svg";
import imageSrc4 from "../../assets/images/icon-youtube.svg";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="neumorphic-container p-5 mb-5">
      <div className="row justify-content-center align-items-center">
        <div className="col-12 col-lg-3 mb-4 mb-lg-0">
          <div className="d-flex justify-content-center">
            <a className="navbar-brand mx-2" href="#!">
              <img className="lazyload-image" src={imageSrc1}
                   alt="x logo" width="auto" height="auto"/>
            </a>
            <a className="navbar-brand mx-2" href="#!">
              <img className="lazyload-image" src={imageSrc2}
                   alt="facebook logo" width="auto" height="auto"/>
            </a>
            <a className="navbar-brand mx-2" href="#!">
              <img className="lazyload-image" src={imageSrc3}
                   alt="linkedin logo" width="auto" height="auto"/>
            </a>
            <a className="navbar-brand mx-2" href="#!">
              <img className="lazyload-image" src={imageSrc4}
                   alt="youtube logo" width="auto" height="auto"/>
            </a>
          </div>
        </div>
        <div className="col-12 col-lg-6 mb-4 mb-lg-0 text-center">
          <span className="footer-text">{t("footer.copyright")}</span>
        </div>
        <div className="col-12 col-lg-3">
          <ul className="d-flex justify-content-center justify-content-lg-between">
            <li className="nav-item">
              <a className="nav-link footer-text" aria-current="page" href="#!">{t("footer.terms")}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link footer-text" href="#!">{t("footer.privacy")}</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
